export const GPU_EXERCISE = 'GpuExercise';
export const EXPORTED_EXERCISES = [GPU_EXERCISE];